import { useCallback, useState } from 'react';

export interface ProfileLeadFormValues {
  name: string;
  email: string;
  phone: string;
  message: string;
  loanAmount: string;
  propertyType: string;
  website: string;
}

// The portal renders this form only in previews: /p/<slug> redirects to the
// public site, whose form sends messages behind its security check. A preview
// submit sends nothing and says so.
export type ProfileLeadStatus = 'idle' | 'preview';

const EMPTY_VALUES: ProfileLeadFormValues = {
  name: '',
  email: '',
  phone: '',
  message: '',
  loanAmount: '',
  propertyType: '',
  website: ''
};

export function useProfileLeadForm() {
  const [values, setValues] = useState<ProfileLeadFormValues>(EMPTY_VALUES);
  const [status, setStatus] = useState<ProfileLeadStatus>('idle');

  const updateValue = useCallback((name: keyof ProfileLeadFormValues, value: string) => {
    setValues((current) => ({ ...current, [name]: value }));
  }, []);

  const submit = useCallback(() => {
    setStatus('preview');
  }, []);

  return {
    values,
    status,
    updateValue,
    submit
  };
}
